module.exports = __webpack_public_path__ + "img/stay_primary_portrait.684a03df.svg";